
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTuneProposal as ObiRadarTuneProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-tune-proposal.js';
 
 
 

 
 export const ObiRadarTuneProposal = createComponent({
   react: React,
   tagName: 'obi-radar-tune-proposal',
   elementClass: ObiRadarTuneProposalElement,
   events: {
     
   }
  });
 
 